import { IoCContainer } from '@writefull/core'

import { AIPromptsErrorManager } from './ai/ai-prompts-error-manager'
import { MessageManager } from './messages/message-manager'
import { NotificationsManager } from './notifications/notifications-manager'
import { SessionManager } from './session/session-manager'
import { SessionStateObserver } from './session/session-state-observer'
import { SignInTrackingManager } from './tracking/sign-in-tracking-manager'
import { TrackingManager } from './tracking/tracking-manager'

export const registerManagers = (container: IoCContainer) => {
  container.bind(SignInTrackingManager).toSelf()
  container.bind(TrackingManager).toSelf()
  container.bind(AIPromptsErrorManager).toSelf()
  container.bind(NotificationsManager).toSelf()
  container.bind(MessageManager).toSelf()
  container.bind(SessionManager).toSelf()
  container.bind(SessionStateObserver).toSelf().inSingletonScope()
}

export const initializeManagers = (container: IoCContainer) => {
  const sessionManager = container.get(SessionManager)
  sessionManager.init()

  const sessionStateObserver = container.get(SessionStateObserver)
  sessionStateObserver.init()
}
